var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPreConfigHover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 135.433,
    height: 112.003,
    viewBox: "0 0 135.433 112.003",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28040",
    "data-name": "Group 28040",
    transform: "translate(-571.295 -528.999)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13173",
    "data-name": "Rectangle 13173",
    width: 135,
    height: 112,
    rx: 10,
    transform: "translate(571.728 529)",
    fill: "#00aec7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_28036",
    "data-name": "Group 28036",
    transform: "translate(18.295 -112)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_17",
    "data-name": "Subtraction 17",
    d: "M15688.224,1241.5H15627.7a10.012,10.012,0,0,1-10-10v-92a10.012,10.012,0,0,1,10-10h115a10.014,10.014,0,0,1,10,10v39.133l-34.564-28.12-69.958,69.95,40.04,21.036Z",
    transform: "translate(-15064.705 -488.5)",
    fill: "#00aec7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_13175",
    "data-name": "Rectangle 13175",
    transform: "translate(601.742 550)",
    fill: "#00aec7",
    stroke: "#fff",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 67,
    height: 67,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28022",
    "data-name": "Group 28022",
    transform: "translate(613.362 564.218)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_99",
    "data-name": "Ellipse 99",
    cx: 10.391,
    cy: 10.391,
    r: 10.391,
    transform: "translate(12.964 10.391)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_100",
    "data-name": "Ellipse 100",
    cx: 2.598,
    cy: 2.598,
    r: 2.598,
    transform: "translate(12.964 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_105",
    "data-name": "Ellipse 105",
    cx: 2.598,
    cy: 2.598,
    r: 2.598,
    transform: "translate(12.964 36.369)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_101",
    "data-name": "Ellipse 101",
    cx: 2.598,
    cy: 2.598,
    r: 2.598,
    transform: "translate(28.551 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_103",
    "data-name": "Ellipse 103",
    cx: 2.598,
    cy: 2.598,
    r: 2.598,
    transform: "translate(28.551 36.369)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_102",
    "data-name": "Ellipse 102",
    cx: 2.598,
    cy: 2.598,
    r: 2.598,
    transform: "translate(20.758 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_104",
    "data-name": "Ellipse 104",
    cx: 2.598,
    cy: 2.598,
    r: 2.598,
    transform: "translate(20.758 36.369)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33812",
    "data-name": "Path 33812",
    d: "M4467.028-1604.512v-17.979h8.19",
    transform: "translate(-4467.028 1644.58)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33814",
    "data-name": "Path 33814",
    d: "M4475.218-1622.491v17.979h-8.19",
    transform: "translate(-4429.453 1626.683)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33813",
    "data-name": "Path 33813",
    d: "M4472.757-1627.638l3.31,4.664-3.31,4.413",
    transform: "translate(-4466.931 1645.27)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33815",
    "data-name": "Path 33815",
    d: "M0,0,3.31,4.664,0,9.078",
    transform: "translate(41.226 7.502) rotate(-90)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreConfigHover);
export default __webpack_public_path__ + "static/media/pre_config_hover.81ab77261d7c39ba51cfa9c49d2e778b.svg";
export { ForwardRef as ReactComponent };